// @flow
import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('li')`
  cursor: pointer;
  border-bottom: 1px solid ${props => props.theme.languageSelector.borderColor};
  line-height: 3.125em;
  height: 3.125em;
  margin: 0 1.25em 0 1.25em;
  color: ${props => props.theme.languageSelector.languageCodeColor};

  &:last-child {
    border: none;
  }

  svg {
    fill: ${props => props.theme.languageSelector.checkMarkColor};
    width: .875em;
    height: .875em;
  }
  .icon-check {
    font-size: .7rem;
    color: ${props => props.theme.languageSelector.checkMarkColor};
  }
`;
